<template>
    <Section
        class="newsletter-signup banner"
        width="sm"
    >
        <NewsletterSignup 
            class="container" 
            :slice-data="slice.primary" 
            :full-width="true" 
        />
    </Section>
</template>

<script>
import NewsletterSignup from '@/components/NewsletterSignup.vue';
export default {
    components: {
        NewsletterSignup
    },
    props: {
        slice: {
            type: Object,
            required: true
        }
    }
};
</script>

<style lang="scss" scoped>
.newsletter-signup {
    background: $lightgray;

    .container {
        @include device(mobile){
            padding-top: 0;
        }
    }
}
</style>